
import { PortableText } from '@portabletext/react';
import { urlFor } from '@/integrations/sanity/client';

const components = {
  types: {
    image: ({ value }: any) => {
      if (!value?.asset?._ref) {
        return null;
      }
      return (
        <div className="my-6">
          <img
            src={urlFor(value).width(800).url()}
            alt={value.alt || ''}
            className="rounded-md mx-auto"
            loading="lazy"
          />
          {value.caption && (
            <div className="text-center text-sm text-muted-foreground mt-2">
              {value.caption}
            </div>
          )}
        </div>
      );
    },
    code: ({value}: any) => {
      return (
        <pre className="bg-secondary p-4 rounded-md overflow-x-auto my-4">
          <code>{value.code}</code>
        </pre>
      );
    },
  },
  block: {
    h1: ({children}: any) => (
      <h1 className="text-3xl font-bold mb-4 mt-8">{children}</h1>
    ),
    h2: ({children}: any) => (
      <h2 className="text-2xl font-bold mb-3 mt-6">{children}</h2>
    ),
    h3: ({children}: any) => (
      <h3 className="text-xl font-bold mb-3 mt-6">{children}</h3>
    ),
    h4: ({children}: any) => (
      <h4 className="text-lg font-bold mb-3 mt-4">{children}</h4>
    ),
    normal: ({children}: any) => (
      <p className="mb-4 leading-relaxed">{children}</p>
    ),
    blockquote: ({children}: any) => (
      <blockquote className="border-l-4 border-primary pl-4 italic my-4">
        {children}
      </blockquote>
    ),
  },
  list: {
    bullet: ({children}: any) => (
      <ul className="list-disc pl-6 mb-4 space-y-2">{children}</ul>
    ),
    number: ({children}: any) => (
      <ol className="list-decimal pl-6 mb-4 space-y-2">{children}</ol>
    ),
  },
  marks: {
    strong: ({children}: any) => <strong>{children}</strong>,
    em: ({children}: any) => <em>{children}</em>,
    code: ({children}: any) => (
      <code className="bg-secondary px-1 py-0.5 rounded text-sm">{children}</code>
    ),
    link: ({value, children}: any) => {
      const target = (value?.href || '').startsWith('http')
        ? '_blank'
        : undefined;
      return (
        <a
          href={value?.href}
          target={target}
          rel={target === '_blank' ? 'noindex nofollow' : undefined}
          className="text-primary underline"
        >
          {children}
        </a>
      );
    },
  },
};

export function PortableTextRenderer({ content }: { content: any }) {
  return <PortableText value={content} components={components} />;
}
